var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { isArr, isValid } from '@formily/shared';
import { useEffect, useRef, useState } from 'react';
const calcBreakpointIndex = (breakpoints, width) => {
    for (let i = 0; i < breakpoints.length; i++) {
        if (width <= breakpoints[i]) {
            return i;
        }
    }
    return 0;
};
const calcFactor = (value, breakpointIndex) => {
    var _a;
    if (Array.isArray(value)) {
        if (breakpointIndex === -1)
            return value[0];
        return (_a = value[breakpointIndex]) !== null && _a !== void 0 ? _a : value[value.length - 1];
    }
    else {
        return value;
    }
};
const factor = (value, breakpointIndex) => isValid(value) ? calcFactor(value, breakpointIndex) : value;
const calculateProps = (target, props) => {
    const { clientWidth } = target;
    const { breakpoints, layout, labelAlign, wrapperAlign, labelCol, wrapperCol } = props, otherProps = __rest(props, ["breakpoints", "layout", "labelAlign", "wrapperAlign", "labelCol", "wrapperCol"]);
    // Need to make sure that breakpoints is an Array
    const breakpointIndex = calcBreakpointIndex(breakpoints, clientWidth);
    return Object.assign({ layout: factor(layout, breakpointIndex), labelAlign: factor(labelAlign, breakpointIndex), wrapperAlign: factor(wrapperAlign, breakpointIndex), labelCol: factor(labelCol, breakpointIndex), wrapperCol: factor(wrapperCol, breakpointIndex) }, otherProps);
};
export const useResponsiveFormLayout = (props) => {
    const [layoutProps, setLayout] = useState(props);
    const ref = useRef(null);
    useEffect(() => {
        if (isArr(props.breakpoints)) {
            const updateUI = () => {
                if (ref.current) {
                    setLayout(calculateProps(ref.current, props));
                }
            };
            const observer = () => {
                updateUI();
            };
            const resizeObserver = new ResizeObserver(observer);
            if (ref.current) {
                resizeObserver.observe(ref.current);
            }
            updateUI();
            return () => {
                resizeObserver.disconnect();
            };
        }
    }, [props]);
    if (!isArr(props.breakpoints)) {
        return { ref, props };
    }
    return {
        ref,
        props: layoutProps,
    };
};
